import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import OTButton from '../../tag/OTButton';
import OTIcon from '../../tag/OTIcon';
import { withRouter } from 'react-router-dom';
import { OTLink } from '../../tag/OTLink';
import BaseQuestionnaireListItem from '../BaseQuestionnaireListItem';
import {formatDate, formatTime} from '../../../utils/TimeUtils';
import moment from 'moment';
import DLL from '@visma/formula/lib/dll';
import Api from "../../../api/Api";
import {timelineSelector} from "../../../data/selector";
import {determineAndAddType} from "../../../views/timeline/data/selector";
import {getDescriptionTypeFromTimelineEventForAssignedForm} from "../../../utils/FormulaUtils";
import {getDepartmentDisplay} from "../../../utils/TimelineUtils";
import {fetchAssignedForms} from "../../../data/questionnaires/actions";

const { id: module_id } = module;


const AssignedQuestionnaires = (props) => {
  const { forms } = props;
  const dispatch = useDispatch();
  const configIds = props?.forms?.map(
    (form) => form.formulaFormId.match(/fm_(\d+)/)[1]
  );
  const [formConfigs, setFormConfigs] = useState(null);

  const openForm = (form, forceReview) => {
    const { formulaFormId, formResponseId, status } = form;
    if ( form.questionnaireOpened === null || form.questionnaireOpened === false ) {
      form.questionnaireOpened = true;
      Api.updateFormAssignment(form);
    }
    if (formResponseId && form.status === 'DRAFT') {
      props.history.push(
        `/questionnaires/fill/${formulaFormId}/${formResponseId}`
      );
    } else if (formResponseId) {
      props.history.push(
        `/questionnaires/response/${formulaFormId}/${formResponseId}`
      );
    } else {
      props.history.push(`/questionnaires/response/${formulaFormId}`);
    }
  };
  useEffect(async () => {
    dispatch(fetchAssignedForms());
    if (configIds.length > 0) {
      setFormConfigs(await DLL.getFormsByIds({ ids: configIds }));
    }
  }, [dispatch]);

  return (
    <div>
      {forms &&
        forms.map((form) => (
          <FormRow
            key={form.id}
            form={form}
            openForm={openForm}
            forceReview={form.status === 'SUBMIT'}
            formConfigs={formConfigs}
          />
        ))}
    </div>
  );
};

const FormRow = ({ form, openForm, forceReview, formConfigs }) => {

  let [formConfig, setFormConfig] = useState(null);
  let [relatedTimelineEvent, setRelatedTimelineEvent] = useState(null);
  const { data: timelineData } = useSelector(timelineSelector);

  useEffect(() => {
    if (timelineData && form) {
      let foundRelatedTimelineEvent = timelineData.find(
          (timelineEvent) => timelineEvent.id === form.timelineEventId
      );
      if (foundRelatedTimelineEvent) {
        foundRelatedTimelineEvent = determineAndAddType(foundRelatedTimelineEvent);
        setRelatedTimelineEvent(foundRelatedTimelineEvent);
      }
    }
  }, [form, timelineData]);

  useEffect(() => {
    if (formConfigs && formConfigs[0]?._id) {
      let foundConfig = formConfigs?.find(
          (config) => config._id === parseInt(form.formulaFormId.split('_')[1])
      );
      setFormConfig(foundConfig);
    }
  }, [formConfigs])

  let description = null;
  if(relatedTimelineEvent) {
    const descriptionType = getDescriptionTypeFromTimelineEventForAssignedForm(relatedTimelineEvent);
    description = (
      <FormattedMessage
        id={`${module_id}.assigned.questionnaire.with.appointment`}
        values={{
          date: formatDate(form.appointmentData.date),
          time: formatTime(form.appointmentData.date),
          department: getDepartmentDisplay(form.appointmentData.department),
          descriptiontype: descriptionType
        }}
      />
    );
  }

  return (
    <BaseQuestionnaireListItem
      left={
        <>
          {
            //Odottavat
            (form.status === 'NULL' || form.status === 'DRAFT') && (
              <div className="ot-queryitem__name">
                <div>
                  {form.title}{' '}
                </div>
                { description && (
                    <div className="ot-queryitem__appointment__description">{description}</div>
                )}
                {form.infoText && (
                  <div className="ot-queryitem__name__infotext">
                    <OTIcon
                      config={{
                        type: 'custom',
                        name: 'palaute',
                        color: 'darkblue',
                      }}
                      style={{
                        height: '13px',
                        width: '15px',
                        marginRight: '5px',
                      }}
                    />
                    <span className={'ot-queryitem__description'}>
                      {form.infoText}
                    </span>
                  </div>
                )}
              </div>
            )
          }
          {
            // Täytetyt/Muokattavat
            form.status === 'SUBMIT' && (
              <OTLink
                className={'ot-queryitem__name completed'}
                link={
                  formConfig?.meta?.allowEditAnswers
                    ? `questionnaires/response/${form.formulaFormId}/${form.formResponseId}`
                    : `/questionnaires/view/${form.id}`
                }
              >
                <div>
                  <div>
                    {form.title}
                    {' '}
                  </div>
                  <div className="ot-queryitem__name__infotext">
                    {form.infoText}
                  </div>
                </div>
              </OTLink>
            )
          }
        </>
      }
      center={
        <>
          {form.endDate != null && (
            <span>Täytä viimeistään {formatDate(form.endDate)}</span>
          )}
        </>
      }
      right={
        <>
          {
            //Odottavat
            (form.status === 'NULL' || form.status === 'DRAFT') && (
              <><OTButton
                color={'light'}
                className={'pull-right ot-queryitem__button'}
                onClick={() => openForm(form, forceReview)}
              >
                <OTIcon
                  config={{ type: 'fa', name: 'icon-pencil' }}
                  style={{ marginRight: '8px' }}
                />
                <FormattedMessage id={'fill'} />
              </OTButton>
            </>
            )
          }
          {
            // Täytetyt/Muokattavat
            form.status === 'SUBMIT' && (
              <>
                <span className={'pull-right ot-queryitem__answered'} style={{textAlign: "end", marginRight: "2px"}}>
                  <OTIcon
                    config={{ type: 'fa', name: 'icon-ok' }}
                    style={{ marginRight: '8px' }}
                  />
                  <FormattedMessage
                    id={`questionnaire.formula.status.COMPLETED`}
                    values={{
                      br: <br />,
                      date: form.formDataLastModifiedDate
                        ? moment(form.formDataLastModifiedDate).format(
                            'D.M.yyyy'
                          )
                        : '',
                    }}
                  >
                    {(txt) => <>{txt}</>}
                  </FormattedMessage>
                </span>
              </>
            )
          }
          <div className='pull-right'>
            {formConfig?.logo && (
                <img
                    src={formConfig?.logo}
                    className={'ot-form-logo'}
                    style={{paddingBottom: "0", paddingRight: "0", float: "right"}}
                    alt={'Logo'}
                />
            )}
          </div>
        </>
      }
    ></BaseQuestionnaireListItem>
  );
};

export default withRouter(AssignedQuestionnaires);
